/* ------------------------------------------------------------------
   JOUBERT — la visionneuse plein écran.

   Elle prend la place de celle du thème : on intercepte « lightbox:open »
   à la capture, donc la visionneuse d'origine — soixante kilo-octets —
   n'est jamais chargée.

   Elle sert aussi hors de la fiche : une visionneuse nommée
   (data-jb-vue="x") s'ouvre depuis tout élément data-jb-vue-ouvre="x".
   C'est le même script, la même feuille (joubert-visionneuse.css) et
   les mêmes commandes (fragment jb-vue-commandes) : une évolution vaut
   pour tous les emplois.

   Des visionneuses d'un même groupe (data-jb-vue-groupe="x") s'enchaînent :
   après la dernière photo on passe à la visionneuse suivante, avant la
   première on revient à la précédente, à la flèche, au clavier comme au
   doigt. L'arrivée glisse depuis le côté, texte compris.

   Ce qu'elle fait de plus : l'ouverture part de l'image cliquée et
   grandit jusqu'à sa place, la légende n'apparaît qu'ici, le zoom se
   fait à la molette et au double-appui, et l'image agrandie se déplace
   au doigt comme à la souris.
   ------------------------------------------------------------------ */
(() => {
  const doux = matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.querySelectorAll('[data-jb-vue]').forEach((vue) => {
    /* Deux emplois. Sans nom, c'est la visionneuse de la fiche : elle
       s'ouvre depuis la galerie du produit. Avec un nom (data-jb-vue="x"),
       elle s'ouvre depuis tout élément qui la désigne
       (data-jb-vue-ouvre="x") : le flux Instagram, par exemple. */
    const nom = vue.dataset.jbVue || '';
    const galerie = nom ? null : document.querySelector('product-gallery');
    if (!nom && !galerie) return;

    const piste = vue.querySelector('[data-jb-vue-piste]');
    const points = vue.querySelector('[data-jb-vue-points]');
    const fermer = vue.querySelector('[data-jb-vue-fermer]');
    const reduire = vue.querySelector('[data-jb-vue-reduire]');
    const images = [...piste.querySelectorAll('.jb-vue-image')];
    if (!images.length) return;

    let index = 0;
    let echelle = 1, dx = 0, dy = 0;

    /* ── Les points de position ── */
    images.forEach((_, i) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'jb-vue-point';
      b.setAttribute('aria-label', 'Photo ' + (i + 1));
      b.addEventListener('click', () => aller(i));
      points.appendChild(b);
    });
    const pastilles = [...points.children];

    /* La visionneuse voisine du même groupe, dans l'ordre de la page. */
    const voisine = (sens) => {
      const groupe = vue.dataset.jbVueGroupe;
      if (!groupe) return null;
      const liste = [...document.querySelectorAll('dialog[data-jb-vue-groupe="' + groupe + '"]')];
      return liste[liste.indexOf(vue) + sens] || null;
    };

    const refleter = () => {
      pastilles.forEach((b, i) => b.classList.toggle('actif', i === index));
      vue.querySelector('[data-jb-vue-sens="-1"]').disabled = index === 0 && !voisine(-1);
      vue.querySelector('[data-jb-vue-sens="1"]').disabled = index === images.length - 1 && !voisine(1);
    };

    /* pendant un deplacement commande, le defilement ne dicte plus l index :
       sinon la fleche et la glissade se contredisent */
    let commande = 0;
    const aller = (i, doucement = true) => {
      /* au-delà des bords, on passe à la visionneuse voisine s'il y en a une */
      if (i < 0 || i > images.length - 1) {
        const sens = i < 0 ? -1 : 1;
        const suivante = voisine(sens);
        if (suivante && suivante.jbVueEntrer) {
          vue.close();
          suivante.jbVueEntrer(sens);
          return;
        }
      }
      index = Math.max(0, Math.min(images.length - 1, i));
      remettre();
      commande = Date.now();
      piste.scrollTo({ left: index * piste.clientWidth, behavior: doucement && !doux ? 'smooth' : 'instant' });
      refleter();
    };

    /* ── Le zoom ── */
    const cadre = () => images[index].querySelector('[data-jb-vue-cadre]');
    const poser = () => {
      const c = cadre();
      c.style.transform = 'translate(' + dx + 'px,' + dy + 'px) scale(' + echelle + ')';
      /* Agrandie, la photo demande sa plus grande version : le navigateur
         avait choisi celle qui suffit a l'ecran, floue une fois zoomee.
         Il garde l'image affichee jusqu'a l'arrivee de la nouvelle. */
      const img = c.querySelector('img');
      if (echelle > 1.02 && img && img.srcset && !img.dataset.jbVueGrand) {
        img.dataset.jbVueGrand = '1';
        img.sizes = '400vw';
      }
      vue.classList.toggle('jb-vue--zoom', echelle > 1.02);
      reduire.hidden = echelle <= 1.02;
    };
    const remettre = () => { echelle = 1; dx = 0; dy = 0; images.forEach((f) => { f.querySelector('[data-jb-vue-cadre]').style.transform = ''; }); vue.classList.remove('jb-vue--zoom'); reduire.hidden = true; };

    const borner = () => {
      const c = cadre();
      const r = c.getBoundingClientRect();
      const debordeX = Math.max(0, (r.width - vue.clientWidth) / 2);
      const debordeY = Math.max(0, (r.height - vue.clientHeight) / 2);
      dx = Math.max(-debordeX, Math.min(debordeX, dx));
      dy = Math.max(-debordeY, Math.min(debordeY, dy));
    };

    const zoomer = (facteur, versX, versY) => {
      const avant = echelle;
      echelle = Math.max(1, Math.min(4, echelle * facteur));
      if (echelle === avant) return;
      /* le point vise reste sous le doigt ou sous la souris */
      const r = vue.getBoundingClientRect();
      const cx = versX - r.left - r.width / 2;
      const cy = versY - r.top - r.height / 2;
      const k = echelle / avant;
      dx = (dx - cx) * k + cx;
      dy = (dy - cy) * k + cy;
      if (echelle === 1) { dx = 0; dy = 0; }
      borner();
      poser();
    };

    vue.addEventListener('wheel', (e) => {
      if (!e.ctrlKey && Math.abs(e.deltaY) < 2) return;
      e.preventDefault();
      zoomer(e.deltaY < 0 ? 1.12 : 0.89, e.clientX, e.clientY);
    }, { passive: false });

    /* ── Au doigt comme à la souris ──
       Zoomée, on déplace la photo. Hors zoom, on fait défiler la piste :
       le tactile le fait tout seul, la souris non. Un glissement franc
       annule le clic, sinon la visionneuse se fermerait en chemin. */
    let tient = false, glisse = false, x0 = 0, y0 = 0, dx0 = 0, dy0 = 0, scroll0 = 0, parcouru = 0, xDernier = 0;
    vue.addEventListener('pointerdown', (e) => {
      /* les commandes, et le pied avec son texte et son lien, gardent leurs gestes */
      if (e.target.closest('button, a, [data-jb-vue-pied]')) return;
      if (echelle <= 1.02 && e.pointerType !== 'mouse') return;
      x0 = e.clientX; y0 = e.clientY; parcouru = 0; xDernier = e.clientX;
      if (echelle > 1.02) {
        tient = true; dx0 = dx; dy0 = dy;
        vue.classList.add('jb-vue--tenue');
      } else {
        glisse = true; scroll0 = piste.scrollLeft;
        piste.style.scrollSnapType = 'none';
        /* le defilement doux relance une animation a chaque assignation et
           annule la precedente : pendant le glisser, on l'eteint */
        piste.style.scrollBehavior = 'auto';
        vue.classList.add('jb-vue--glisse');
      }
      vue.setPointerCapture(e.pointerId);
    });
    vue.addEventListener('pointermove', (e) => {
      if (!tient && !glisse) return;
      parcouru = Math.max(parcouru, Math.hypot(e.clientX - x0, e.clientY - y0));
      xDernier = e.clientX;
      if (tient) {
        dx = dx0 + (e.clientX - x0);
        dy = dy0 + (e.clientY - y0);
        borner(); poser();
      } else {
        piste.scrollLeft = scroll0 - (e.clientX - x0);
      }
    });
    const lacher = () => {
      if (glisse) {
        piste.style.scrollSnapType = '';
        piste.style.scrollBehavior = '';
        /* un geste franc avance d'une photo, meme court : on juge au
           mouvement et non a la distance parcourue sur la piste */
        /* au bord la piste ne bouge plus : on juge au geste lui-même */
        const ecart = x0 - xDernier;
        if (Math.abs(ecart) > 60) aller(index + (ecart > 0 ? 1 : -1));
        else aller(index);
      }
      tient = false; glisse = false;
      vue.classList.remove('jb-vue--tenue', 'jb-vue--glisse');
    };
    vue.addEventListener('pointerup', lacher);
    vue.addEventListener('pointercancel', lacher);

    /* ── Deux doigts, et le double appui ── */
    let ecart0 = 0, echelle0 = 1;
    const ecart = (t) => Math.hypot(t[0].clientX - t[1].clientX, t[0].clientY - t[1].clientY);
    vue.addEventListener('touchstart', (e) => {
      if (e.touches.length !== 2) return;
      ecart0 = ecart(e.touches); echelle0 = echelle;
    }, { passive: true });
    vue.addEventListener('touchmove', (e) => {
      if (e.touches.length !== 2 || !ecart0) return;
      e.preventDefault();
      const milieuX = (e.touches[0].clientX + e.touches[1].clientX) / 2;
      const milieuY = (e.touches[0].clientY + e.touches[1].clientY) / 2;
      const voulue = echelle0 * (ecart(e.touches) / ecart0);
      zoomer(voulue / echelle, milieuX, milieuY);
    }, { passive: false });
    vue.addEventListener('touchend', () => { ecart0 = 0; });

    /* Au doigt, la piste défile d'elle-même ; au bord elle s'arrête. Un
       glissement franc vers l'extérieur passe alors à la voisine. */
    let tx0 = null, ty0 = 0;
    vue.addEventListener('touchstart', (e) => {
      tx0 = e.touches.length === 1 && echelle <= 1.02 ? e.touches[0].clientX : null;
      ty0 = e.touches.length === 1 ? e.touches[0].clientY : 0;
    }, { passive: true });
    vue.addEventListener('touchend', (e) => {
      if (tx0 === null || !e.changedTouches.length) return;
      const ddx = e.changedTouches[0].clientX - tx0;
      const ddy = e.changedTouches[0].clientY - ty0;
      tx0 = null;
      if (Math.abs(ddx) < 60 || Math.abs(ddx) < Math.abs(ddy) * 1.5) return;
      if (ddx < 0 && index === images.length - 1) aller(index + 1);
      else if (ddx > 0 && index === 0) aller(index - 1);
    }, { passive: true });

    /* Hors zoom, un clic sur la photo ferme — le curseur en croix le dit.
       Zoomee, elle ne se ferme plus : on la deplace, et le double clic la
       ramene a sa taille. */
    let neDansLaVue = false;
    vue.addEventListener('pointerdown', () => { neDansLaVue = true; }, true);
    vue.addEventListener('click', (e) => {
      /* les commandes, et le pied avec son texte et son lien, gardent leurs gestes */
      if (e.target.closest('button, a, [data-jb-vue-pied]')) return;
      if (!neDansLaVue) return;
      neDansLaVue = false;
      /* un deplacement n'est pas un appui : sans cela la photo se
         refermait au relachement du glisser */
      if (parcouru > 8) { parcouru = 0; return; }
      /* agrandie, un appui la ramene a sa taille ; le suivant ferme */
      if (echelle > 1.02) { remettre(); return; }
      vue.close();
    });

    reduire.addEventListener('click', remettre);

    /* ── Navigation ── */
    vue.querySelectorAll('[data-jb-vue-sens]').forEach((b) => {
      b.addEventListener('click', () => aller(index + Number(b.dataset.jbVueSens)));
    });
    /* au niveau du document : selon ou le focus a atterri, la touche
       n'atteignait pas toujours le dialogue */
    addEventListener('keydown', (e) => {
      if (!vue.open) return;
      /* une touche ne sert qu'une fois : en passant a la visionneuse
         voisine, celle-ci l'aurait traitee a son tour */
      if (e.key === 'ArrowRight') { e.preventDefault(); e.stopImmediatePropagation(); aller(index + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); e.stopImmediatePropagation(); aller(index - 1); }
      if (e.key === 'Escape' && echelle > 1.02) { e.preventDefault(); remettre(); }
    });
    let attente = false;
    piste.addEventListener('scroll', () => {
      if (attente) return;
      attente = true;
      requestAnimationFrame(() => {
        attente = false;
        if (echelle > 1.02 || Date.now() - commande < 700) return;
        const i = Math.round(piste.scrollLeft / piste.clientWidth);
        if (i !== index) { index = i; refleter(); }
      });
    }, { passive: true });

    /* ── L'ouverture part de l'image de la page ── */
    const ouvrir = (depuis) => {
      const media = depuis ? depuis.closest('[data-media-id]') : null;
      const id = media ? media.dataset.mediaId : null;
      const trouve = images.findIndex((f) => f.dataset.mediaId === id);
      index = trouve >= 0 ? trouve : 0;

      vue.showModal();
      neDansLaVue = false;
      remettre();
      piste.scrollTo({ left: index * piste.clientWidth, behavior: 'instant' });
      refleter();

      const source = depuis ? depuis.querySelector('img') || depuis : null;
      if (!source || doux) return;
      const depart = source.getBoundingClientRect();
      const arrivee = images[index].querySelector('img').getBoundingClientRect();
      if (!depart.width || !arrivee.width) return;

      /* on part de la place exacte de la photo cliquée et on grandit
         jusqu'à la sienne : le visiteur ne perd pas des yeux ce qu'il
         vient de désigner */
      const k = depart.width / arrivee.width;
      const ex = depart.left + depart.width / 2 - (arrivee.left + arrivee.width / 2);
      const ey = depart.top + depart.height / 2 - (arrivee.top + arrivee.height / 2);
      images[index].querySelector('[data-jb-vue-cadre]').animate(
        [{ transform: 'translate(' + ex + 'px,' + ey + 'px) scale(' + k + ')' }, { transform: 'none' }],
        { duration: 380, easing: 'cubic-bezier(.22,.61,.36,1)' }
      );
      vue.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 220, easing: 'ease-out' });
    };

    /* Arrivée depuis la visionneuse voisine : on entre par le bord d'où
       l'on vient, photo et texte glissent ensemble. */
    vue.jbVueEntrer = (sens) => {
      index = sens > 0 ? 0 : images.length - 1;
      vue.showModal();
      neDansLaVue = false;
      remettre();
      piste.scrollTo({ left: index * piste.clientWidth, behavior: 'instant' });
      refleter();
      if (doux) return;
      const courbe = 'cubic-bezier(.22,.61,.36,1)';
      images[index].querySelector('[data-jb-vue-cadre]').animate(
        [{ transform: 'translateX(' + (sens * 38) + '%)', opacity: 0 }, { transform: 'none', opacity: 1 }],
        { duration: 440, easing: courbe });
      const pied = vue.querySelector('[data-jb-vue-pied]');
      if (pied) {
        pied.animate([{ transform: 'translateX(' + (sens * 90) + 'px)', opacity: 0 }, { transform: 'none', opacity: 1 }],
          { duration: 440, delay: 60, easing: courbe, fill: 'backwards' });
      }
    };

    fermer.addEventListener('click', () => vue.close());
    vue.addEventListener('close', remettre);

    /* ── Ouverture par un élément de la page ──
       Le lien garde sa destination : sans script, ou avec Ctrl, Maj ou le
       clic du milieu, il mène où il dit. */
    if (nom) {
      document.querySelectorAll('[data-jb-vue-ouvre="' + nom + '"]').forEach((lien) => {
        lien.addEventListener('click', (e) => {
          if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button) return;
          e.preventDefault();
          ouvrir(lien);
        });
      });
      return;
    }

    /* ── On prend la main avant le thème ──
       L'évènement du thème est émis par le bouton, pas par la photo :
       on retient donc la dernière photo touchée, et à défaut on lit
       celle que la vignette active désigne. */
    let dernierMedia = null;
    galerie.addEventListener('pointerdown', (e) => {
      const m = e.target.closest('.product-gallery__media');
      if (m) dernierMedia = m;
    }, { capture: true, passive: true });

    const mediaCourant = () => {
      if (dernierMedia && dernierMedia.isConnected) return dernierMedia;
      const vignette = galerie.querySelector('[aria-current="true"][data-media-id]');
      if (vignette) return galerie.querySelector('.product-gallery__media[data-media-id="' + vignette.dataset.mediaId + '"]') || vignette;
      const piste = galerie.querySelector('.product-gallery__carousel');
      const medias = [...galerie.querySelectorAll('.product-gallery__media')];
      if (piste && medias.length) return medias[Math.round(piste.scrollLeft / piste.clientWidth)] || medias[0];
      return medias[0] || null;
    };

    const interception = (e) => {
      e.stopPropagation();
      e.preventDefault?.();
      ouvrir(mediaCourant());
      dernierMedia = null;
    };
    galerie.addEventListener('lightbox:open', interception, true);
    document.addEventListener('lightbox:open', interception, true);
  });
})();
